module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Capitolo uno")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Anche in una vita ordinaria possono accadere le cose più straordinarie. Ogni mattina, negli ultimi undici anni, Elias Martin faceva colazione con porridge caldo e spesse fette di pane alla melassa ricoperte di marmellata di bacche di pernice. Poi, pioggia o sole, iniziava la passeggiata solitaria dalla sua casetta blu in Elizabeth Avenue a Grand Bank, Terranova, giù per la baia e, finché la neve invernale lo rendeva possibile, su per le colline fino a Cape.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questo pellegrinaggio solitario gli permetteva di piangere sua moglie Eileen senza che nessuno si intromettesse nel suo dolore. Cosa ancora più importante, gli permetteva di parlare con lei senza che nessuno lo considerasse più pazzo di quello che era. Quella era una passeggiata che avevano condiviso per quasi quarant'anni, fino a quando si era ammalata, e lui sentiva ancora la sua mancanza e aveva ancora bisogno di percepire la sua confortante presenza. Pensava che la sua lunga, dolorosa e infine fatale battaglia con il cancro sarebbe stata la parte peggiore della sua vita. Ora sapeva che stare senza di lei era anche peggio.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La gente sulla costa di Grand Bank poteva impostare gli orologi basandosi su Elias Martin. Ogni mattina, anche quando la nebbia arrivava fluttuando da Fortune, vedevano la sua figura ricurva arrampicarsi e scomparire come un contrabbandiere nella foschia che percorreva la costa. Potevano mettere a bollire una pentola di minestra quando partiva ed essere sicuri, quando fosse apparso di nuovo, che le patate, le carote e le rape sarebbero state morbide e dolci.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mavis Emberly era una di quelli che cucinavano basandosi su Elias Martin per scandire i tempi di preparazione della sua dose settimanale di zuppa di piselli. «Eccolo là», fece notare a suo marito, Francis, «È ora di mettere la zuppa sul fuoco».")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "18",
      "src": "d2d_images/image037.png",
      "width": "23"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un’ora e mezza dopo Francis Emberly mormorò «qualcosa sta bruciando in cucina, tesoro». La sig.ra Emberly corse in cucina per spegnere la brodaglia dal fondo annerito, aggiungendo un'infarinatura di maledizioni poco religiose e sicuramente immorali e si rese subito conto che c'era qualcos'altro che non andava oltre alla sua zuppa rovinata. Elias non era tornato. «O forse non l'ho notato», decise.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Solo il mattino seguente, il resto del mondo scoprì ciò che la sua pentola di zuppa di piselli bruciacchiata aveva già annunciato. Elias Martin fu trovato morto stecchito da una coppia di escursionisti, disteso in silenzio sul sentiero ben battuto che lui ed Eileen avevano percorso insieme per tanti anni.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Un attacco di cuore” fu quello che si disse la gente del vicinato mentre si stringeva davanti a un caffè al bar locale, fucina di pettegolezzi. “Un ictus” sussurravano le signore della chiesa mentre lasciavano la riunione per la pianificazione della festa in giardino alla parrocchia anglicana. Ma anche mentre il corpo dell'ormai defunto Elias Martin giaceva su una fredda lastra alla clinica locale, alcuni di loro sospettavano che qualcosa o qualcun altro fossero coinvolti nella morte di quel camminatore solitario. L'unico a saperlo con certezza era Elias Martin che di sicuro non parlava. Chi avrebbe risolto il mistero di quell’uomo che amava camminare a Cape?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0